const initSubscriptionOptions = () => {

  if (document.querySelector('[data-subscription-options]') === null) return;
  const optionsContainer = document.querySelector('[data-subscription-options]');
  
  const radioButtons = optionsContainer.querySelectorAll('input[type="radio"]');
  const radioIndicators = optionsContainer.querySelectorAll('[data-subscription-radio]');
  const checkoutButton = document.querySelector('[data-checkout-button]');

  if (radioButtons.length === 0 || radioIndicators.length === 0 || checkoutButton === null) return;

  radioButtons.forEach((radio, index) => {
    radio.addEventListener('change', () => {
      radioIndicators.forEach((indicator, indIndex) => {
        if (index === indIndex) {
          indicator.classList.add('border-9');
          radio.checked = true;
          checkoutButton.href = radio.value;
        } else {
          indicator.classList.remove('border-9');
          radioButtons[indIndex].checked = false;
        }
      });
    });
  });

};

export default initSubscriptionOptions;